import * as Yup from 'yup';

const errorMsg = 'Must be greater than 0';

export const productCheckRequestSchema = Yup.object().shape({
  customerAmountRefund: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
  productType: Yup.string().required(),
  sellerAmountRefund: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
  achRefNumber: Yup.string().required(),
  payeeName: Yup.string().required(),
  reason: Yup.string().required(),
  provider: Yup.string().required(),
  lenderCode: Yup.string().required(),
  amountRequested: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
  cancelledDate: Yup.string().required()
});
